import EditLegalPagesForm from 'components/legalPages/EditLegalPagesForm'
import CommonLayout from 'layouts/DashboardLayout'
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import CareerPageEdit from 'components/legalPages/CareerPageEdit';
import TeamPageEdit from 'components/legalPages/TeamPageEdit';
import AboutUsEdit from 'components/legalPages/AboutUsEdit';
import { Box, Button, Stack, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import { useSelector } from 'react-redux';
import AngleRightIcon from 'common/customIcons/angle_right';
import ReviewPageEdit from '../../components/legalPages/ReviewPageEdit';
import PricingPageEdit from '../../components/legalPages/PricingPageEdit';
import ZipcodePageEdit from '../../components/legalPages/ZipcodePageEdit';
import DeliveryPageEdit from 'components/legalPages/DeliveryPageEdit';
import ServiceGuaranteePageEdit from 'components/legalPages/ServiceGuaranteePageEdit';
import DiscreetCannabisDeliveryPageEdit from 'components/legalPages/DiscreetCannabisDeliveryPageEdit';
import PaymentsPageEdit from 'components/legalPages/PaymentsPageEdit';
import LabTestingStandardsPageEdit from 'components/legalPages/LabTestingStandardsPageEdit';
import SameDayDeliveryPageEdit from 'components/legalPages/SameDayDelivery';

const EditLegalPage = () => {
    const navigate = useNavigate()
    const { legalId = '' } = useParams();

    const [searchParams, setSearchParams] = useSearchParams();
    const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
    const [formData, setFormData] = useState({ status: true })
    const { singleLegal } = useSelector((state => state.common));
    const [linkState, setLinkState] = useState("")
    const fullRoleTabheading = useMemo(() => searchParams.get('heading'), [searchParams]);
    const fullRoleTabSlug = useMemo(() => searchParams.get('slug'), [searchParams]);


    useEffect(() => {
        setTimeout(() => {
            setLinkState("")
        }, 2000);
    }, [linkState])

    useEffect(() => {
        if (singleLegal?.status === undefined) {
            setFormData({ status: true })
        }
        else {
            setFormData({ status: singleLegal?.status })
        }
    }, [singleLegal])


    return (
        <CommonLayout>

            <Box pt={{ xs: 2, sm: 3, lg: 4 }} pl={{ xs: 2, sm: 3, lg: 4 }} pr={{ xs: 2, sm: 3, lg: 4 }}>
                <Box display="flex" alignItems="center" justifyContent={'space-between'}>
                    <Box display="flex" alignItems="center" color='text.main' lineHeight={1} mb={3.5}>
                        <span style={{ cursor: 'pointer' }} onClick={() => { navigate(`/manages/static`) }}>
                            <AngleRightIcon fontSize="14px" />
                        </span>
                        <Typography variant='h6' fontWeight="semibold" ml={.75}>   {fullRoleTabheading}</Typography>

                    </Box>

                    {
                        singleLegal?.slug &&
                        <Box
                            display="flex"
                            sx={{ cursor: 'pointer' }}
                            alignItems="center"
                            color="text.main"
                            lineHeight={1}
                            gap={2}
                            mb={3.5}
                            style={{ position: "relative" }}
                        >
                            <svg style={{ cursor: 'pointer' }} xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" onClick={() => {
                                const link = `${fullRoleTab === "hemp" ? process.env.REACT_APP_HEMP_FRONTEND_URL : fullRoleTab === "stilo" ? process.env.REACT_APP_STILO_FRONTEND_URL : process.env.REACT_APP_HYPERWOLF_FRONTEND_URL}/${singleLegal?.slug}`;
                                navigator.clipboard.writeText(link)
                                    .then(() => setLinkState("Link copied!"))
                                    .catch(err => { });
                            }}>
                                <g clipPath="url(#clip0_14557_35992)">
                                    <path d="M8.61203 16.7513C6.65952 16.7513 5.07031 15.162 5.07031 13.2095V4.66797H3.61203C2.34784 4.66797 1.32031 5.69534 1.32031 6.95953V18.2095C1.32031 19.4737 2.34784 20.5013 3.61203 20.5013H14.0286C15.2928 20.5013 16.3203 19.4737 16.3203 18.2095V16.7513H8.61203Z" fill="#0163FF" />
                                    <path d="M19.6536 2.79172C19.6536 1.52585 18.6277 0.5 17.362 0.5H8.61203C7.34616 0.5 6.32031 1.52585 6.32031 2.79172V13.2083C6.32031 14.4742 7.34616 15.5 8.61203 15.5H17.362C18.6277 15.5 19.6536 14.4742 19.6536 13.2083V2.79172Z" fill="#0163FF" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_14557_35992">
                                        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            {
                                linkState &&
                                <p className="link-status">{linkState}</p>
                            }

                            <Typography
                                variant="body"
                                component="a"
                                href={`${fullRoleTab === "hemp" ? process.env.REACT_APP_HEMP_FRONTEND_URL : fullRoleTab === "stilo" ? process.env.REACT_APP_STILO_FRONTEND_URL : process.env.REACT_APP_HYPERWOLF_FRONTEND_URL}/${singleLegal?.slug}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ textDecoration: 'none', color: 'inherit' }}
                                style={{
                                    borderRadius: "26px",
                                    color: "#0163FF",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    border: "1px solid #0163FF",
                                    padding: "10px 16px"
                                }}
                            >
                                {`${fullRoleTab === "hemp" ? process.env.REACT_APP_HEMP_FRONTEND_URL : fullRoleTab === "stilo" ? process.env.REACT_APP_STILO_FRONTEND_URL : process.env.REACT_APP_HYPERWOLF_FRONTEND_URL}/${singleLegal?.slug}`}
                            </Typography>
                        </Box>

                    }
                </Box>
                {
                    // (legalId === 'career' || legalId === 'about_us' || legalId === 'meet_the_team') &&

                    <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2}>
                        <Box className="cannabinoids-tabs">
                            <Stack direction='row' gap={1} sx={{ background: '#ffffff' }} className="mb-0">

                                <Button className={fullRoleTab === 'hemp' ? 'active' : ''} onClick={() => {
                                    setSearchParams({ roleTab: 'hemp', heading: fullRoleTabheading, slug: fullRoleTabSlug })
                                }} variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px' }}>
                                    Hemp
                                </Button>
                                <Button onClick={() => {
                                    setSearchParams({ roleTab: 'hyperwolf', heading: fullRoleTabheading, slug: fullRoleTabSlug })
                                }} variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px' }} className={fullRoleTab === 'hyperwolf' ? 'active' : ''} >
                                    Hyperwolf
                                </Button>
                                <Button className={fullRoleTab === 'stilo' ? 'active' : ''}
                                    // disabled
                                    onClick={() => {
                                        setSearchParams({ roleTab: 'stilo', heading: fullRoleTabheading, slug: fullRoleTabSlug })
                                    }}
                                    // onClick={() => { setSearchParams({ roleTab: 'stilo' ,heading:fullRoleTabheading}) }}
                                    variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px' }}>
                                    Stilo
                                </Button>
                            </Stack>
                        </Box>

                        <Box display='flex' alignItems='center' gap={1.25}>
                            <Typography variant='h5' fontWeight='semibold' color='secondary'>Status</Typography>
                            <Stack direction='row' alignItems='center' gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor='#ffffff'>
                                <MDButton
                                    sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                                    type='button'
                                    variant={formData?.status ? "contained" : "text"}
                                    color={formData?.status ? "success" : "dark"}
                                    size='small'
                                    onClick={() => setFormData((prev) => ({ ...prev, status: true }))}
                                >
                                    Active
                                </MDButton>
                                <MDButton
                                    sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                                    type='button'
                                    variant={!formData?.status ? "contained" : "text"}
                                    color={!formData?.status ? "error" : "dark"}
                                    size='small'
                                    onClick={() => setFormData((prev) => ({ ...prev, status: false }))}
                                >
                                    Inactive
                                </MDButton>
                            </Stack>
                        </Box>
                    </Stack>
                }
            </Box>

            {/* Slug base */}
            {
                legalId === 'career_template' ? <CareerPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                    legalId === 'about_us_template' ? <AboutUsEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'meet_the_team_template' ? <TeamPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'review_template' ? <ReviewPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'pricing_template' ? <PricingPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'zipcode_template' ? <ZipcodePageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'delivery_template' ? <DeliveryPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'service_guarantee' ? <ServiceGuaranteePageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'discreet_cannabis_delivery' ? <DiscreetCannabisDeliveryPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'payments' ? <PaymentsPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'lab_testing_standards' ? <LabTestingStandardsPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :
                        legalId === 'same_day_delivery' ? <SameDayDeliveryPageEdit legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} /> :

                            <EditLegalPagesForm legalId={legalId} dataProps={formData} fullRoleTabSlug={fullRoleTabSlug} />
            }

        </CommonLayout>
    )
}

export default EditLegalPage
